import { windowWidth } from "src/styles/global";
import styled from "styled-components";

const Container = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;  
  gap: 6px;
  width: 100%;
  padding: 6px 15px 0 15px;
`;

const CurrentTenant = styled.span`
  color: ${(props) => props.theme.colors.gray};
`;

const Board = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 15px;

  > :first-child {
    max-width: 300px;
    width: 300px;

    @media (max-width: ${windowWidth.mobile.large}) {
      max-width: unset;
      width: unset;
    }
  }
`;

const TenantsBoard = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  align-content: start;
  overflow: hidden;
  overflow-y: scroll;
  gap: 15px;
  padding: 5px 5px 102px;

  @media (max-width: ${windowWidth.mobile.large}) {
    grid-template-columns: minmax(200px, auto);
  }
`;

export { Container, Header, Board, TenantsBoard, CurrentTenant };